import { render, staticRenderFns } from "./lid-list.vue?vue&type=template&id=2050e3de&"
import script from "./lid-list.vue?vue&type=script&lang=js&"
export * from "./lid-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports